import React from 'react';
import { graphql } from 'gatsby';
import Layout from 'components/Layout';
import SEO from 'components/SEO';
import CareersHero from 'components/_page/careers/Hero';
import JoinUs from 'components/_page/careers/JoinUs';
import Positions from 'components/_page/careers/Positions';
import Values from 'components/_page/careers/Values';
import Trapdoor from 'components/Trapdoor';

export default ({ data }) => {
  const careers = data.prismic.allCareerss.edges[0].node;

  return (
    <Layout>
      <SEO
        title={careers.social_title || 'Careers'}
        description={careers.social_description ? careers.social_description : null}
        image={careers.social_image ? careers.social_image.url : null}
      />

      <CareersHero
        heading={careers.hero_heading}
        terms={careers.hero_terms}
        image={careers.hero_image}
        illustration={careers.hero_illustration}
        imagePosition='right'
        duration={careers.hero_term_duration || 6000}
      />

      <JoinUs
        heading={careers.join_us_heading}
        content={careers.join_us_content}
        background={careers.join_us_background}
        quotes={careers.join_us_quotes}
      />


      <Positions
        heading={careers.positions_heading}
        content={careers.positions_content}
      />

      <Values
        heading={careers.values_heading}
        values={careers.values}
      />

      <Trapdoor
        intro={careers.trapdoor_intro}
        heading={careers.trapdoor_heading}
        buttonText={careers.trapdoor_button_text}
        destination={careers.trapdoor_destination}
      />
    </Layout>
  );
};

export const query = graphql`
  {
    prismic {
      allCareerss {
        edges {
          node {
            hero_heading
            hero_terms {
              text
            }
            hero_term_duration
            hero_image
            hero_illustration {
              ... on PRISMIC__FileLink {
                _linkType
                name
                size
                url
              }
            }
            join_us_heading
            join_us_content
            join_us_background
            join_us_quotes {
              quote
              cite
              image
            }
            positions_heading
            positions_content
            values_heading
            values {
              heading
              text
            }
            trapdoor_intro
            trapdoor_heading
            trapdoor_button_text
            trapdoor_destination
            social_title
            social_description
            social_image
          }
        }
      }
    }
  }
`;
